"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _themeUi = require("theme-ui");
var _reactFeather = require("react-feather");
var _react = require("react");
var _Box = _interopRequireDefault(require("../../../../Layout/Box"));
var _Text = _interopRequireDefault(require("../Text/Text"));
var _Text2 = _interopRequireDefault(require("../../../Text"));
var _Hidden = require("../../../../Modules/Hidden");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

/** @jsx jsx */
var PasswordInput = function PasswordInput(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'input' : _b,
    passwordProps = (0, _tslib.__rest)(_a, ["variant"]);
  return (0, _themeUi.jsx)(_Box.default, (0, _tslib.__assign)({
    as: _Text.default,
    __themekey: "forms.password",
    __css: {
      position: 'relative'
    },
    variant: variant
  }, passwordProps));
};
var PasswordToggle = function PasswordToggle(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'toggleButton' : _b,
    passwordProps = (0, _tslib.__rest)(_a, ["variant"]);
  return (0, _themeUi.jsx)(_Box.default, (0, _tslib.__assign)({
    as: "button",
    __themekey: "forms.password",
    __css: {
      position: 'absolute',
      cursor: 'pointer',
      top: '50%',
      transform: 'translate(0, -50%)',
      right: '12px',
      background: 'transparent',
      border: 'none',
      color: 'rgb(146, 146, 146)',
      '&:hover': {
        color: 'rgb(146, 146, 146)',
        background: 'transparent'
      },
      ':focus': {
        outline: '1px dotted',
        outlineColor: 'slategrey',
        outlineOffset: '2px'
      }
    },
    variant: variant
  }, passwordProps));
};
var PasswordHiddenIcon = function PasswordHiddenIcon(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'eye' : _b,
    hiddenIconProps = (0, _tslib.__rest)(_a, ["variant"]);
  return (0, _themeUi.jsx)(_reactFeather.Eye, (0, _tslib.__assign)({
    sx: {
      variant: "forms.password." + variant
    }
  }, hiddenIconProps));
};
var PasswordVisibleIcon = function PasswordVisibleIcon(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'eyeOff' : _b,
    visibleIconProps = (0, _tslib.__rest)(_a, ["variant"]);
  return (0, _themeUi.jsx)(_reactFeather.EyeOff, (0, _tslib.__assign)({
    sx: {
      variant: "forms.password." + variant
    }
  }, visibleIconProps));
};
var Password = function Password(_a) {
  var hideText = _a.hideText,
    showText = _a.showText,
    props = (0, _tslib.__rest)(_a, ["hideText", "showText"]);
  var _b = (0, _react.useState)(false),
    showPassword = _b[0],
    setShowPassword = _b[1];
  var type = showPassword ? 'text' : 'password';
  return (0, _themeUi.jsx)(_Box.default, {
    sx: {
      position: 'relative'
    }
  }, (0, _themeUi.jsx)(PasswordInput, (0, _tslib.__assign)({}, props, {
    type: type
  })), (0, _themeUi.jsx)(PasswordToggle, {
    "aria-labelledby": "eye-description",
    onClick: function onClick() {
      return setShowPassword(!showPassword);
    },
    type: "button",
    variant: "passwordToggle"
  }, showPassword ? (0, _themeUi.jsx)(PasswordHiddenIcon, {
    "aria-describedby": "password hidden"
  }) : (0, _themeUi.jsx)(PasswordVisibleIcon, {
    "aria-describedby": "password visible"
  }), (0, _themeUi.jsx)(_Text2.default, {
    id: "eye-description",
    css: _Hidden.hiddenCss
  }, showPassword ? hideText : showText)));
};
Password.displayName = 'Password';
Password.defaultProps = {
  hideText: 'Hide password',
  showText: 'Show password'
};
var _default = Password;
exports.default = _default;